import { render } from "./BrandStyriaDigitalDevelopment.vue?vue&type=template&id=049de80a"
import script from "./BrandStyriaDigitalDevelopment.vue?vue&type=script&lang=ts"
export * from "./BrandStyriaDigitalDevelopment.vue?vue&type=script&lang=ts"

import "./BrandStyriaDigitalDevelopment.vue?vue&type=style&index=0&id=049de80a&lang=scss"
script.render = render

export default script